import { Component, inject } from "@angular/core";
import { DialogRef } from "@progress/kendo-angular-dialog";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "wk-cancel-confirmation",
    templateUrl: "./cancel-confirmation.component.html",
    host: {
        "(document:keydown.escape)": "handleEsc()",
    },
    imports: [TranslatePipe],
})
export class CancelConfirmationComponent {
    private ref = inject(DialogRef);

    constructor() {}

    handleEsc() {
        this.ref.close();
    }
}
